import { DataRoom } from './DataRoom';
import { DataRoomTeaserPreview } from './DataRoomTeaserPreview';
import { Deal } from './Deal';
import { Guid } from './Shared';
import { StructureTranches, Tier1BankTypes, Tier2BankTypes } from './TrancheEvaluation';

export interface TeaserView {
	deal: Deal;
	dataRoom: DataRoom;
	teaserPreview: DataRoomTeaserPreview;
	teasers: DataRoomTeaser[];
	usedTranches: StructureTranches[];
}

export interface DataRoomTeaser {
	guid: Guid;
	bankDealProfileGuid: Guid;
	bankGuid: Guid;
	bankContactGuid: Guid;
	firstName: string;
	lastName: string;
	emailAddress: string;
	bankName: string;
	affiliateLender: string | null;
	bankHasNda: boolean;
	tier1Type: Tier1BankTypes | null;
	tier2Type: Tier2BankTypes | null;
	tier3ContactTypes: string[];
	score: number;
	scoreLastUpdatedDate: Date | null;
	sentOn: Date | null;
	decisionOn: Date | null;
	structureType: StructureTranches | null;
	trancheType: TrancheTypes | null;
	decisionStatus: TeaserDecisionStatus;
	lenderDeclineReasons: string[];
	otherDeclineReason: string | null;
	reasonDetail: string | null;
	reEngagePoint: string | null;
	finderFeeAgreements: string[];
	reconciliationUrl: string | null;
	isAutomaticTeaser: boolean;
	isDeleted: boolean;
	deletedOn: Date | null;
	deletedBy: string | null;
	hasFinderFeeAgreement: boolean;
	includeReferralLanguage: boolean;
	ignoreAtLaunch: boolean;
	receiveTeasersSms: boolean;
	hasAccessedDataRoom: boolean;
	lenderScoreFlag: boolean;
}

export type TeaserDecisionStatus = keyof typeof TeaserDecisionStatusMap;
export const TeaserDecisionStatusMap = {
	Unsent: 'Unsent',
	Sent: 'Sent',
	Accepted: 'Accepted',
	Declined: 'Declined',
};

export type TrancheTypes = keyof typeof TrancheTypesMap;
export const TrancheTypesMap = {
	Unknown: 'Unknown',
	SeniorCash: 'Senior Cash',
	VentureDebt: 'Venture Debt',
	AssetBased: 'Asset-Based',
	JuniorCash: 'Junior Cash',
	Sba: 'SBA',
};

export interface SearchOtherDealsResultItem {
	dataRoomTeaserId: number;
	dataRoomTeaserGuid: Guid;
	dealGuid: Guid | null;
	dataRoomGuid: Guid | null;
	bankContactGuid: Guid | null;
	bankDealProfileGuid: Guid | null;
	bankGuid: Guid;
	companyName: string | null;
	dealName: string | null;
	bankName: string | null;
	firstName: string;
	lastName: string;
	decisionStatus: string;
	score?: number;
	isPicked: boolean;
	isExcluded: boolean;
	lenderScoreFlag: boolean;
}
